import { render, staticRenderFns } from "./VolumeSlider.vue?vue&type=template&id=318ddae7&scoped=true&"
import script from "./VolumeSlider.vue?vue&type=script&lang=js&"
export * from "./VolumeSlider.vue?vue&type=script&lang=js&"
import style0 from "./VolumeSlider.vue?vue&type=style&index=0&id=318ddae7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318ddae7",
  null
  
)

export default component.exports